export const environment = {
  production: true,
  buildId: '3098552560320441',
  configFile: 'config.json',
};
